export function SvgIcon({ title, size = 18, children, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
    </svg>
  );
}

export function WhatsAppIcon(props) {
  return (
    <SvgIcon title="WhatsApp" {...props}>
      <path
        fill="currentColor"
        d="M12 2a10 10 0 0 0-8.68 15l-.9 3.27a1 1 0 0 0 1.23 1.23L6.9 20.6A10 10 0 1 0 12 2Zm0 18a8 8 0 0 1-4.04-1.09 1 1 0 0 0-.8-.09l-2.24.62.6-2.18a1 1 0 0 0-.1-.8A8 8 0 1 1 12 20Z"
      />
      <path
        fill="currentColor"
        d="M16.9 13.85c-.2-.1-1.2-.6-1.39-.66-.19-.07-.33-.1-.47.1-.14.2-.55.66-.67.8-.12.13-.25.15-.45.05a6.5 6.5 0 0 1-1.93-1.2 7.2 7.2 0 0 1-1.34-1.66c-.14-.25 0-.38.1-.5.1-.1.2-.25.3-.37.1-.12.14-.2.2-.34.06-.13.03-.25-.02-.35-.05-.1-.47-1.15-.64-1.57-.17-.42-.35-.36-.47-.37h-.4c-.14 0-.35.05-.54.25-.19.2-.71.7-.71 1.7 0 1 .73 1.98.84 2.11.1.14 1.44 2.2 3.5 3.09.49.21.88.34 1.17.44.5.16.96.14 1.32.08.4-.06 1.2-.5 1.37-.98.17-.48.17-.9.12-.98-.05-.09-.18-.14-.38-.24Z"
      />
    </SvgIcon>
  );
}

export function GooglePlayIcon(props) {
  return (
    <SvgIcon title="Google Play" {...props}>
      <path fill="currentColor" d="M4.5 3.2v17.6c0 .5.6.8 1 .5l10-8.3c.3-.3.3-.7 0-1L5.5 2.7c-.4-.3-1-.1-1 .5Z" />
      <path fill="currentColor" opacity="0.75" d="M15.9 12 19.7 8.8c.5-.4.4-1.2-.2-1.5L17 6 13.6 9l2.3 3Z" />
      <path fill="currentColor" opacity="0.75" d="M17 18l2.5-1.3c.6-.3.7-1.1.2-1.5L15.9 12l-2.3 3L17 18Z" />
    </SvgIcon>
  );
}

export function AppleIcon(props) {
  return (
    <SvgIcon title="App Store" {...props}>
      <path
        fill="currentColor"
        d="M16.7 13.2c0-1.8 1.5-2.7 1.6-2.8-.9-1.3-2.2-1.5-2.7-1.5-1.1-.1-2.1.7-2.7.7-.6 0-1.4-.7-2.3-.7-1.2 0-2.4.7-3 1.7-1.3 2.2-.3 5.6.9 7.4.6.9 1.3 1.9 2.3 1.8.9 0 1.3-.6 2.4-.6 1.1 0 1.4.6 2.4.6 1 0 1.7-.9 2.3-1.8.7-1 1-2 1-2.1 0 0-2.2-.8-2.2-2.7ZM14.9 6.8c.5-.7.9-1.6.8-2.6-.8.1-1.8.6-2.4 1.3-.5.6-1 1.6-.9 2.5.9.1 1.9-.4 2.5-1.2Z"
      />
    </SvgIcon>
  );
}

export function FacebookIcon(props) {
  return (
    <SvgIcon title="Facebook" {...props}>
      <path
        fill="currentColor"
        d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.7-1.6H17V4.9c-.3 0-1.4-.1-2.7-.1-2.7 0-4.5 1.6-4.5 4.6V11H7v3h2.8v8h3.7Z"
      />
    </SvgIcon>
  );
}

export function InstagramIcon(props) {
  return (
    <SvgIcon title="Instagram" {...props}>
      <path
        fill="currentColor"
        d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9A3.5 3.5 0 0 0 20 16.5v-9A3.5 3.5 0 0 0 16.5 4h-9Z"
      />
      <path fill="currentColor" d="M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />
      <path fill="currentColor" d="M17.8 6.6a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z" />
    </SvgIcon>
  );
}

export function LinkedInIcon(props) {
  return (
    <SvgIcon title="LinkedIn" {...props}>
      <path
        fill="currentColor"
        d="M6.5 9.2H3.8V20h2.7V9.2Zm.2-3.3A1.6 1.6 0 1 1 5 4.3 1.6 1.6 0 0 1 6.7 5.9ZM20.2 20h-2.7v-5.3c0-1.3-.5-2.2-1.7-2.2-1 0-1.6.7-1.9 1.4-.1.2-.1.6-.1.9V20h-2.7s0-9.5 0-10.8h2.7v1.5c.4-.7 1.2-1.7 3-1.7 2.1 0 3.7 1.4 3.7 4.4V20Z"
      />
    </SvgIcon>
  );
}

export function YouTubeIcon(props) {
  return (
    <SvgIcon title="YouTube" {...props}>
      <path
        fill="currentColor"
        d="M21.6 7.2a3 3 0 0 0-2.1-2.1C17.7 4.6 12 4.6 12 4.6s-5.7 0-7.5.5A3 3 0 0 0 2.4 7.2 31 31 0 0 0 2 12c0 1.6.1 3.2.4 4.8a3 3 0 0 0 2.1 2.1c1.8.5 7.5.5 7.5.5s5.7 0 7.5-.5a3 3 0 0 0 2.1-2.1c.3-1.6.4-3.2.4-4.8 0-1.6-.1-3.2-.4-4.8ZM10.3 15V9l5.2 3-5.2 3Z"
      />
    </SvgIcon>
  );
}

export function TikTokIcon(props) {
  return (
    <SvgIcon title="TikTok" {...props}>
      <path
        fill="currentColor"
        d="M15.7 3c.3 2.3 1.8 3.7 4 3.9v3c-1.6 0-2.9-.5-4-1.4v6.1c0 3.1-2.5 5.4-5.6 5.4A5.4 5.4 0 0 1 4.7 14c0-3 2.4-5.4 5.4-5.4.5 0 .9.1 1.3.2v3.2c-.4-.2-.8-.3-1.3-.3-1.2 0-2.2 1-2.2 2.2 0 1.3 1 2.3 2.3 2.3 1.3 0 2.2-.9 2.2-2.6V3h3.3Z"
      />
    </SvgIcon>
  );
}

